<script>
  import { LazyLoad } from "path2percent";
  import Drop from "./Drop.svelte";
  /**
   * @typedef {Object} Props
   * @property {any} parentId
   * @property {string} [name]
   * @property {number} [percent]
   * @property {string} [link]
   */

  /** @type {Props} */
  let {
    parentId,
    name = "loading",
    percent = 0,
    link = "#"
  } = $props();
</script>

​​
<LazyLoad >
  {#snippet children({ viewport: show })}
    <div class="wc-dam-cap__bar__container">
      <div>
        <div class="wc-dam-cap__drop__container">
          <Drop {percent} />
        </div>
        ​
        <a href={link} tabindex="0" title="see {name} information">
          <div class="wc-dam-cap__bar">
            <div
              class="wc-dam-cap__bar__fill"
              style="height: {show ? percent : 0}%;"
  ></div>
          </div>
        </a>
      </div>
      <label class="wc-dam-cap__bar__label" for={parentId + name}>
        <a href={link}>{name}</a>
        ​
      </label>
    </div>
  {/snippet}
</LazyLoad>
